/* esm.sh - base64-js@1.5.1 */
export * from "/*base64-js@1.5.1/esnext/base64-js.mjs";
export { default } from "/*base64-js@1.5.1/esnext/base64-js.mjs";
